import React from 'react'
import styled from 'styled-components'
import {
	BACKGROUND_FREE_SEAT,
	PRIMARY_LIGHT,
	LIGHTYELLOW
} from '../../../styles/colors.style'

const spacing = '2px'
const StyledContainer = styled.div`
	align-items: center;
	background: ${({ available, hasDiscount }) =>
		available && hasDiscount
			? LIGHTYELLOW
			: available && !hasDiscount
			? BACKGROUND_FREE_SEAT
			: PRIMARY_LIGHT};
	border-radius: 5px;
	color: ${({ hasDiscount }) => (hasDiscount ? 'black' : 'white')};
	cursor: pointer;
	display: flex;
	height: ${({ busSeatsWidth }) =>
		`calc(${busSeatsWidth} / 5 - 2 * ${spacing})`};
	justify-content: center;
	left: ${({ y, busSeatsWidth }) =>
		`calc(${y % 5} * ${busSeatsWidth} / 5 + ${spacing})`};
	position: absolute;
	top: ${({ x, busSeatsWidth, busSeatVerticalSpacing }) =>
		`calc(${x} * calc(${busSeatsWidth} / 5 + ${spacing} + ${busSeatVerticalSpacing}))`};
	width: ${({ busSeatsWidth }) =>
		`calc(${busSeatsWidth} / 5 - 2 * ${spacing})`};

	&:hover {
		${({ available }) => (available ? 'opacity: 0.8;' : '')}
	}
`

class BusSeat extends React.Component {
	render() {
		const {
			x,
			y,
			onClick,
			discount,
			available,
			busSeatNumber,
			busSeatsWidth,
			busSeatVerticalSpacing
		} = this.props
		return (
			<StyledContainer
				id={busSeatNumber}
				y={y}
				x={x - 1}
				onClick={onClick}
				discount={discount}
				hasDiscount={discount > 0}
				data-discount={discount}
				data-has-iscount={discount > 0}
				available={available}
				busSeatsWidth={busSeatsWidth}
				busSeatVerticalSpacing={busSeatVerticalSpacing}>
				{busSeatNumber}
			</StyledContainer>
		)
	}
}

export default BusSeat
